import { Record, List } from 'immutable';

export default class CustomerListRecord extends Record({
  id: undefined,
  name: undefined,
  createdAt: undefined,
  itemCount: undefined,
  initialItemCount: undefined,
  links: new List(),
}) {
}
